export default function MySQL_SUBDATE() {
  return (
    <div>
      <h2>MySQL_SUBDATE</h2>    </div>
  );
}